import React, { useEffect, useState } from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import { ClockIcon, AlertCircleIcon } from 'lucide-react';
const PLANS = [{
  key: 'basico',
  emoji: '📘',
  name: 'PACK 100 CITAS',
  subtitle: '4 libros + 400 citas + 7 bonos',
  idealPara: 'Familias que quieren empezar a crear momentos especiales con sus hijos desde hoy mismo.',
  oldPrice: '$65',
  price: '$12.97',
  checkoutUrl: 'https://recursopack.com/cart/40898068152369:1',
  ctaText: '→ QUIERO MI PACK BÁSICO Y EMPEZAR HOY',
  isVip: false
}, {
  key: 'completo',
  emoji: '🏆',
  name: 'PACK FAMILIAR COMPLETO',
  subtitle: '6 libros + 600 citas + 7 bonos',
  idealPara: 'Incluye todo el Básico más el Libro de Pareja y el Libro Familiar completo. Ideal para familias que quieren cubrir todas las relaciones y tener herramientas para toda la familia durante años.',
  oldPrice: '$95',
  price: '$16.97',
  checkoutUrl: 'https://recursopack.com/cart/40916383236145:1',
  ctaText: '→ QUIERO EL PACK COMPLETO PARA TODA MI FAMILIA',
  badge: 'MÁS ELEGIDO',
  isVip: true
}];
export function PricingSection() {
  const fadeIn = useFadeIn();
  const [timeLeft, setTimeLeft] = useState(85408);
  useEffect(() => {
    const startDelay = setTimeout(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
      const timer = setInterval(() => {
        setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
      }, 1000);
      return () => clearInterval(timer);
    }, 3000);
    return () => clearTimeout(startDelay);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <section id="pricing" className="py-10 md:py-20 px-4 bg-[#111111] scroll-mt-10" data-id="element-117">
      <div className="max-w-4xl mx-auto" data-id="element-118">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-119">
          {/* Countdown Block */}
          <div className="text-center mb-10 md:mb-12" data-id="element-120">
            <div className="inline-flex items-center gap-2 bg-purple-900/60 border border-purple-500/40 text-purple-300 font-bold text-xs md:text-base px-4 py-2 md:px-5 md:py-2 rounded-full mb-5 md:mb-6" data-id="element-121">
              <ClockIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-122" />
              <span data-id="element-123">PRECIO DE LANZAMIENTO — CIERRA EN:</span>
            </div>

            <div className="flex items-center justify-center gap-2 md:gap-3 mb-5 md:mb-6" data-id="element-124">
              <div className="bg-[#1a1a2e] border border-gray-700 rounded-xl px-2 py-2 md:px-6 md:py-4 min-w-[60px] md:min-w-[90px]" data-id="element-125">
                <div className="text-2xl md:text-5xl font-black text-white" data-id="element-126">
                  {hours.toString().padStart(2, '0')}
                </div>
                <div className="text-[10px] md:text-sm text-gray-500 font-medium mt-1" data-id="element-127">
                  hs
                </div>
              </div>
              <span className="text-xl md:text-4xl font-black text-purple-400" data-id="element-128">
                :
              </span>
              <div className="bg-[#1a1a2e] border border-gray-700 rounded-xl px-2 py-2 md:px-6 md:py-4 min-w-[60px] md:min-w-[90px]" data-id="element-129">
                <div className="text-2xl md:text-5xl font-black text-white" data-id="element-130">
                  {minutes.toString().padStart(2, '0')}
                </div>
                <div className="text-[10px] md:text-sm text-gray-500 font-medium mt-1" data-id="element-131">
                  min
                </div>
              </div>
              <span className="text-xl md:text-4xl font-black text-purple-400" data-id="element-132">
                :
              </span>
              <div className="bg-[#1a1a2e] border border-gray-700 rounded-xl px-2 py-2 md:px-6 md:py-4 min-w-[60px] md:min-w-[90px]" data-id="element-133">
                <div className="text-2xl md:text-5xl font-black text-white" data-id="element-134">
                  {seconds.toString().padStart(2, '0')}
                </div>
                <div className="text-[10px] md:text-sm text-gray-500 font-medium mt-1" data-id="element-135">
                  seg
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center gap-2 text-yellow-400 font-bold text-xs md:text-base mb-6 md:mb-8" data-id="element-136">
              <AlertCircleIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-137" />
              <span data-id="element-138">Después sube a su precio normal. No vuelve.</span>
            </div>

            <div className="max-w-md mx-auto mb-8 md:mb-10" data-id="element-139">
              <div className="flex items-center justify-between text-sm text-gray-400 mb-2" data-id="element-140">
                <span data-id="element-141">Cupos al precio de lanzamiento</span>
                <span className="font-bold text-yellow-400" data-id="element-142">Quedan pocos</span>
              </div>
              <div className="w-full bg-gray-800 rounded-full h-3 overflow-hidden" data-id="element-143">
                <div className="h-full rounded-full bg-gradient-to-r from-purple-600 to-purple-400" style={{
                width: '82%'
              }} data-id="element-144"></div>
              </div>
              <p className="text-xs text-gray-500 mt-1.5 text-right" data-id="element-145">
                82% de los cupos ya tomados
              </p>
            </div>
          </div>

          {/* Pricing Header */}
          <div className="text-center mb-8 md:mb-10" data-id="element-146">
            <h2 className="text-3xl md:text-6xl font-black text-white mb-4 uppercase tracking-tight" data-id="element-147">
              ELEGÍ TU PACK
            </h2>
          </div>

          {/* Plan Cards - Side by Side */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 md:mb-10" data-id="element-148">
            {PLANS.map(plan => <div key={plan.key} className={`relative rounded-2xl p-5 md:p-8 flex flex-col ${plan.isVip ? 'bg-[#0d0d1a] border-2 border-yellow-500/50' : 'bg-[#0d0d1a] border border-gray-700'}`} data-id="element-149">
                {plan.badge && <div className="absolute -top-4 left-1/2 -translate-x-1/2" data-id="element-150">
                    <span className="inline-flex items-center gap-1.5 bg-gradient-to-r from-yellow-500 via-amber-400 to-yellow-500 text-black text-[10px] md:text-sm font-black px-3 md:px-4 py-1.5 rounded-full uppercase tracking-wider shadow-lg whitespace-nowrap" data-id="element-151">
                      ⭐ {plan.badge}
                    </span>
                  </div>}

                <div className="flex items-center gap-2 mb-2 mt-2" data-id="element-152">
                  <span className="text-xl md:text-2xl" data-id="element-153">{plan.emoji}</span>
                  <h3 className="text-base md:text-xl font-black text-white uppercase tracking-wide" data-id="element-154">
                    {plan.name}
                  </h3>
                </div>

                <p className={`text-sm md:text-base font-bold mb-4 ${plan.isVip ? 'text-yellow-400' : 'text-blue-400'}`} data-id="element-155">
                  {plan.subtitle}
                </p>

                <div className="bg-[#111122] border border-gray-700/50 rounded-xl p-3 md:p-4 mb-5 md:mb-6 flex-1" data-id="element-156">
                  <p className="text-sm md:text-base text-gray-300" data-id="element-157">
                    <span className="font-bold italic text-white" data-id="element-158">
                      Ideal para:{' '}
                    </span>
                    {plan.idealPara}
                  </p>
                </div>

                <div className="mb-4 md:mb-5" data-id="element-159">
                  <span className="text-base md:text-lg text-gray-500 line-through font-medium mr-2" data-id="element-160">
                    {plan.oldPrice}
                  </span>
                  <span className="text-3xl md:text-5xl font-black text-white" data-id="element-161">
                    {plan.price}
                  </span>
                </div>

                <a href={plan.checkoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full mb-3" data-id="element-162">
                  <div className={`w-full text-center font-black text-sm md:text-lg uppercase tracking-wide py-3.5 md:py-4 rounded-xl transition-all ${plan.isVip ? 'bg-yellow-400 text-black md:hover:bg-yellow-300' : 'bg-blue-600 text-white md:hover:bg-blue-500'}`} data-id="element-163">
                    {plan.ctaText}
                  </div>
                </a>

                <p className="text-center text-xs md:text-sm text-gray-500" data-id="element-164">
                  🌎 Pagalo en tu moneda local
                </p>
              </div>)}
          </div>

          <div className="flex flex-col items-center justify-center gap-2 mt-2 text-gray-500 text-xs md:text-sm" data-id="element-165">
            <div className="flex items-center gap-2 md:gap-4" data-id="element-166">
              <span data-id="element-167">🔒 Pago 100% seguro</span>
              <span data-id="element-168">•</span>
              <span data-id="element-169">🛡️ Garantía 7 días</span>
            </div>
            <span data-id="element-170">
              🌎 Pagalo en tu moneda local — Tarjeta de crédito, débito y más
            </span>
          </div>

          {/* Master-Pack Details Section */}
          <div className="mt-16 md:mt-20" data-id="element-171">
            <div className="text-center mb-8 md:mb-10" data-id="element-172">
              <h3 className="text-xl md:text-4xl font-black text-yellow-400 mb-3" data-id="element-173">
                🕊️ ¿QUÉ AGREGA EL PACK FAMILIAR COMPLETO?
              </h3>
              <p className="text-base md:text-xl text-gray-300 font-medium" data-id="element-174">
                El Pack 100 Citas cubre la relación con tus hijos. El Pack
                Familiar Completo cubre TODA la familia.
              </p>
            </div>

            {/* What the complete pack adds */}
            <div className="mb-10 md:mb-12" data-id="element-175">
              <div className="space-y-4 md:space-y-6" data-id="element-176">
                <div className="bg-[#1a1a2e] border-2 border-pink-500/40 rounded-2xl p-5 md:p-8" data-id="element-177">
                  <div className="flex items-start gap-4" data-id="element-178">
                    <span className="text-3xl md:text-4xl flex-shrink-0" data-id="element-179">
                      💑
                    </span>
                    <div data-id="element-180">
                      <h4 className="text-xl md:text-2xl font-black text-pink-400 mb-2" data-id="element-181">
                        100 Citas en Pareja
                      </h4>
                      <p className="text-sm md:text-lg text-gray-300 font-medium" data-id="element-182">
                        Actividades, conversaciones y momentos diseñados para
                        reconectar como pareja. Porque la relación de los padres
                        también necesita atención y cuidado. Incluye espacio
                        para fotos y recuerdos 📸
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-[#1a1a2e] border-2 border-green-500/40 rounded-2xl p-5 md:p-8" data-id="element-183">
                  <div className="flex items-start gap-4" data-id="element-184">
                    <span className="text-3xl md:text-4xl flex-shrink-0" data-id="element-185">
                      👨‍👩‍👧‍👦
                    </span>
                    <div data-id="element-186">
                      <h4 className="text-xl md:text-2xl font-black text-green-400 mb-2" data-id="element-187">
                        100 Citas en Familia
                      </h4>
                      <p className="text-sm md:text-lg text-gray-300 font-medium" data-id="element-188">
                        Planes para disfrutar todos juntos: padres e hijos.
                        Juegos, aventuras y experiencias para fortalecer el
                        vínculo familiar completo. Incluye espacio para fotos y
                        recuerdos 📸
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Pack Completo summary */}
            <div className="mb-10 md:mb-12" data-id="element-189">
              <h4 className="text-lg md:text-2xl font-black text-yellow-400 mb-5 md:mb-6 text-center" data-id="element-190">
                EL PACK FAMILIAR COMPLETO INCLUYE:
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-191">
                {[{
                emoji: '💜',
                text: '100 Citas Mamá e Hija'
              }, {
                emoji: '💙',
                text: '100 Citas Mamá e Hijo'
              }, {
                emoji: '💖',
                text: '100 Citas Papá e Hija'
              }, {
                emoji: '💚',
                text: '100 Citas Papá e Hijo'
              }, {
                emoji: '💑',
                text: '100 Citas en Pareja'
              }, {
                emoji: '👨‍👩‍👧‍👦',
                text: '100 Citas en Familia'
              }, {
                emoji: '🎁',
                text: '7 Bonos Exclusivos incluidos'
              }, {
                emoji: '📸',
                text: 'Espacio para fotos y recuerdos en cada cita'
              }].map((item, i) => <div key={i} className="flex items-start gap-3 bg-[#1a1a2e] border border-gray-700/50 rounded-xl p-3.5" data-id="element-192">
                    <span className="text-xl md:text-2xl flex-shrink-0" data-id="element-193">
                      {item.emoji}
                    </span>
                    <p className="text-sm md:text-base text-gray-300 font-medium" data-id="element-194">
                      {item.text}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>

          {/* Repeated Plan Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 md:mb-10 mt-10 md:mt-12" data-id="element-195">
            {PLANS.map(plan => <div key={`bottom-${plan.key}`} className={`relative rounded-2xl p-5 md:p-8 flex flex-col ${plan.isVip ? 'bg-[#0d0d1a] border-2 border-yellow-500/50' : 'bg-[#0d0d1a] border border-gray-700'}`} data-id="element-196">
                {plan.badge && <div className="absolute -top-4 left-1/2 -translate-x-1/2" data-id="element-197">
                    <span className="inline-flex items-center gap-1.5 bg-gradient-to-r from-yellow-500 via-amber-400 to-yellow-500 text-black text-[10px] md:text-sm font-black px-3 md:px-4 py-1.5 rounded-full uppercase tracking-wider shadow-lg whitespace-nowrap" data-id="element-198">
                      ⭐ {plan.badge}
                    </span>
                  </div>}

                <div className="flex items-center gap-2 mb-2 mt-2" data-id="element-199">
                  <span className="text-xl md:text-2xl" data-id="element-200">{plan.emoji}</span>
                  <h3 className="text-base md:text-xl font-black text-white uppercase tracking-wide" data-id="element-201">
                    {plan.name}
                  </h3>
                </div>

                <p className={`text-sm md:text-base font-bold mb-4 ${plan.isVip ? 'text-yellow-400' : 'text-blue-400'}`} data-id="element-202">
                  {plan.subtitle}
                </p>

                <div className="mb-4 md:mb-5" data-id="element-203">
                  <span className="text-base md:text-lg text-gray-500 line-through font-medium mr-2" data-id="element-204">
                    {plan.oldPrice}
                  </span>
                  <span className="text-3xl md:text-5xl font-black text-white" data-id="element-205">
                    {plan.price}
                  </span>
                </div>

                <a href={plan.checkoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full mb-3" data-id="element-206">
                  <div className={`w-full text-center font-black text-sm md:text-lg uppercase tracking-wide py-3.5 md:py-4 rounded-xl transition-all ${plan.isVip ? 'bg-yellow-400 text-black md:hover:bg-yellow-300' : 'bg-blue-600 text-white md:hover:bg-blue-500'}`} data-id="element-207">
                    {plan.ctaText}
                  </div>
                </a>

                <p className="text-center text-xs md:text-sm text-gray-500" data-id="element-208">
                  🌎 Pagalo en tu moneda local
                </p>
              </div>)}
          </div>

          <div className="flex flex-col items-center justify-center gap-2 mt-2 text-gray-500 text-xs md:text-sm" data-id="element-209">
            <div className="flex items-center gap-2 md:gap-4" data-id="element-210">
              <span data-id="element-211">🔒 Pago 100% seguro</span>
              <span data-id="element-212">•</span>
              <span data-id="element-213">🛡️ Garantía 7 días</span>
            </div>
            <span data-id="element-214">
              🌎 Pagalo en tu moneda local — Tarjeta de crédito, débito y más
            </span>
          </div>
        </div>
      </div>
    </section>;
}